import { Injectable } from '@angular/core';
import { AdressesCompltService } from '../adressesComplt/adresses-complt.service';
import { CaracteristiquesService } from '../caracteristiques/caracteristiques.service';
import { ConditionsService } from '../conditions/conditions.service';
import { CriteresService } from '../criteres/criteres.service';
import { DescriptionService } from '../description/description.service';
import { DureeService } from '../duree/duree.service';
import { InfosSupService } from '../infosSup/infos-sup.service';
import { JustificationsService } from '../justifications/justifications.service';
import { LotsService } from '../lots/lots.service';
import { NatureMarcheService } from '../natureMarche/nature-marche.service';
import { ProcedureService } from '../procedure/procedure.service';
import { RenseignementsService } from '../renseignements/renseignements.service';
import { TypeDelaisService } from '../typeDelais/type-delais.service';

@Injectable({
  providedIn: 'root'
})
export class InitialService {

  constructor(
    public adressesCompltService: AdressesCompltService,
    public caracteristiquesService: CaracteristiquesService,
    public conditionsService: ConditionsService,
    public criteresService: CriteresService,
    public descriptionService: DescriptionService,
    public dureeService: DureeService,
    public infosSupService: InfosSupService,
    public justificationsService: JustificationsService,
    public lotsService: LotsService,
    public procedureService: ProcedureService,
    public renseignementsService: RenseignementsService,
    public natureMarcheService: NatureMarcheService,
    public typeDelaisService: TypeDelaisService
  ) {
  }
}
